import JSZip from 'jszip';

function escapeXml(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

function paragraph(text, { bold = false, size = 1100, align = 'l' } = {}) {
  const b = bold ? ' b="1"' : '';
  return `<a:p><a:pPr algn="${align}"/><a:r><a:rPr lang="pt-BR" sz="${size}"${b}/><a:t>${escapeXml(text)}</a:t></a:r></a:p>`;
}

function textBoxAnchor({ id, name, col, colOff, row, rowOff, cx, cy, paragraphs }) {
  return `<xdr:oneCellAnchor><xdr:from><xdr:col>${col}</xdr:col><xdr:colOff>${colOff}</xdr:colOff><xdr:row>${row}</xdr:row><xdr:rowOff>${rowOff}</xdr:rowOff></xdr:from><xdr:ext cx="${cx}" cy="${cy}"/><xdr:sp><xdr:nvSpPr><xdr:cNvPr id="${id}" name="${name}"/><xdr:cNvSpPr txBox="1"/></xdr:nvSpPr><xdr:spPr><a:xfrm><a:off x="0" y="0"/><a:ext cx="${cx}" cy="${cy}"/></a:xfrm><a:prstGeom prst="rect"><a:avLst/></a:prstGeom><a:noFill/></xdr:spPr><xdr:txBody><a:bodyPr vertOverflow="clip" horzOverflow="clip" wrap="square" lIns="0" tIns="0" rIns="0" bIns="0" anchor="ctr"/><a:lstStyle/>${paragraphs}</xdr:txBody></xdr:sp><xdr:clientData/></xdr:oneCellAnchor>`;
}

/** Cuadros del pie, en la misma posición que Invoice 5019. El texto es el del PDF. */
export function htFooterTextBoxXml(staticContent) {
  const names = staticContent.HT_DIGITAL_SIGNATORY_BLOCK.split('\n')
    .map((line) => paragraph(line, { bold: true }))
    .join('');
  const signed = [
    'Assinado de forma digital',
    'por DENILSON',
    'GONCALVES PADILHA:',
    '00363896929',
  ]
    .map((line) => paragraph(line, { bold: false, size: 1000 }))
    .join('');

  const icpLines = staticContent.HT_ICP_VALIDATION_LINES.map((line) =>
    paragraph(line, { size: 800, align: 'ctr' })
  ).join('');
  const tech = [
    paragraph(staticContent.HT_TECH_SIGN, { bold: true, size: 800, align: 'ctr' }),
    paragraph(staticContent.HT_TECH_SIGN_EN, { size: 800, align: 'ctr' }),
  ].join('');

  return [
    textBoxAnchor({
      id: 80,
      name: 'HT nombres firma',
      col: 3,
      colOff: 552450,
      row: 56,
      rowOff: 85725,
      cx: 1095375,
      cy: 781240,
      paragraphs: names,
    }),
    textBoxAnchor({
      id: 81,
      name: 'HT firma digital',
      col: 3,
      colOff: 2530475,
      row: 56,
      rowOff: 38100,
      cx: 1670049,
      cy: 781240,
      paragraphs: signed,
    }),
    textBoxAnchor({
      id: 82,
      name: 'HT texto ICP',
      col: 4,
      colOff: 1552574,
      row: 55,
      rowOff: 20000,
      cx: 2381250,
      cy: 320000,
      paragraphs: icpLines,
    }),
    `<xdr:twoCellAnchor><xdr:from><xdr:col>2</xdr:col><xdr:colOff>2254667</xdr:colOff><xdr:row>63</xdr:row><xdr:rowOff>19050</xdr:rowOff></xdr:from><xdr:to><xdr:col>3</xdr:col><xdr:colOff>2669542</xdr:colOff><xdr:row>63</xdr:row><xdr:rowOff>19050</xdr:rowOff></xdr:to><xdr:cxnSp><xdr:nvCxnSpPr><xdr:cNvPr id="83" name="HT linea firma"/><xdr:cNvCxnSpPr/></xdr:nvCxnSpPr><xdr:spPr><a:prstGeom prst="line"><a:avLst/></a:prstGeom><a:ln w="9525"><a:solidFill><a:srgbClr val="000000"/></a:solidFill></a:ln></xdr:spPr></xdr:cxnSp><xdr:clientData/></xdr:twoCellAnchor>`,
    textBoxAnchor({
      id: 84,
      name: 'HT tecnico',
      col: 2,
      colOff: 2443230,
      row: 63,
      rowOff: 60000,
      cx: 2800000,
      cy: 420000,
      paragraphs: tech,
    }),
  ].join('');
}

export async function insertHtFooterTextBoxes(buffer, staticContent) {
  const zip = await JSZip.loadAsync(buffer);
  const drawingPath = Object.keys(zip.files).find((name) =>
    /^xl\/drawings\/drawing\d+\.xml$/.test(name)
  );
  if (!drawingPath) return buffer;
  const xml = await zip.file(drawingPath).async('string');
  if (xml.includes('name="HT nombres firma"')) return buffer;
  const next = xml.replace('</xdr:wsDr>', `${htFooterTextBoxXml(staticContent)}</xdr:wsDr>`);
  zip.file(drawingPath, next);
  return zip.generateAsync({ type: 'arraybuffer' });
}
